import Vue from 'vue'
import Vuex from 'vuex'

import app from '@/store/modules/app'
import analytics from '@/store/modules/analytics'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {app, analytics}
})



// WEBPACK FOOTER //
// ./src/store/index.js